import { ImagePlusIcon } from "lucide-react"
import { Input } from "~/components/ui/input"
import { Label } from "~/components/ui/label"
import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar"

export function LogoUploadField({
	label,
	disabled,
	id = "logo",
	currentLogo,
	fallback = "Orbit"
}: {
	label: string
	disabled?: boolean
	id?: string
	currentLogo?: string | null
	fallback?: string
}) {
	return (
		<div className="flex flex-col gap-4 rounded-xl bg-background p-4 sm:flex-row sm:items-center">
			<Avatar className="size-16 shrink-0 rounded-2xl control-raised bg-background-elevated">
				<AvatarImage
					src={currentLogo ?? undefined}
					alt=""
					className="object-cover"
				/>
				<AvatarFallback className="rounded-2xl bg-background-elevated text-xl font-semibold text-orbit-text">
					{fallback.slice(0, 2).toUpperCase()}
				</AvatarFallback>
			</Avatar>
			<div className="grid min-w-0 flex-1 gap-2">
				<Label htmlFor={id} className="flex items-center gap-2">
					<ImagePlusIcon className="size-4 text-icons" />
					{label}
				</Label>
				<Input
					id={id}
					name="logo"
					type="file"
					accept="image/png, image/jpeg"
					disabled={disabled}
					variant="file"
				/>
			</div>
		</div>
	)
}
